import { render, staticRenderFns } from "./CarsList.vue?vue&type=template&id=fe236b40&"
import script from "./CarsList.vue?vue&type=script&lang=js&"
export * from "./CarsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports